module.exports = __webpack_public_path__ + "static/media/cancel-service_3.9ff21a5f.png";